import Card from '@material-ui/core/Card';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import * as moment from 'moment';
import * as React from 'react';
import { Line } from 'react-chartjs-2';
import { stylesheet } from "typestyle";
import { ChartData, Logger, Reading } from './Models';

const css = stylesheet({
	card: {
		height: '60vh',
		position: 'relative',
		width: '100%',
	}
})

// The chart configuration (without the data)
const config: Chart.ChartOptions = {
	animation: {
		duration: 0
	},
	legend: {
		display: true,
		labels: {
			fontColor: 'rgb(0, 0, 0)',
			usePointStyle: true,
		}
	},
	maintainAspectRatio: false,
	responsive: true,
	scales: {
		xAxes: [{
			display: true,
			distribution: 'linear',
			scaleLabel: {
				display: true,
				fontColor: 'rgb(0, 0, 0)',
				labelString: 'Time'
			},
			ticks: {
				fontColor: 'rgb(0, 0, 0)'
			},
			time: {
				displayFormats: {
					day: 'D. MMM',
					hour: 'HH:00',
					minute: 'HH:mm',
					second: 'HH:mm:ss',
				},
				max: moment().add(1, 'seconds').toISOString(),
				unit: 'second',
			},
			type: 'time',
		}],
		yAxes: [{
			display: true,
			gridLines: {
				color: 'rgb(255, 204, 204)',
			},
			id: 'y-axis-ph',
			scaleLabel: {
				display: true,
				fontColor: 'rgb(102, 0, 0)',
				labelString: 'pH'
			},
			ticks: {
				fontColor: 'rgb(102, 0, 0)',
				max: 14,
				min: 0,
			}
		}]
	},
	tooltips: {
		enabled: false,
		intersect: false,
		mode: 'x',
		position: 'nearest'
	},
};

@observer
export default class TimeSeriesChartPH extends React.Component<{
	loggers: Array<Logger>,
	chartData: ChartData,
}>{

	render() {
		const { loggers } = this.props;
		const chartData = toJS(this.props.chartData)
		const time = config.scales!.xAxes![0]!.time!

		const dataForDateMapping: Array<Reading> = chartData.ph


		time.max = moment().add(1, 'seconds').toISOString();
		const mindate = moment.min(dataForDateMapping.map(r => r.x));
		if (mindate) {
			if (mindate.isBefore(moment().subtract(7, 'days'))) {
				time.unit = 'day';
			}
			else if (mindate.isBefore(moment().subtract(24, 'hours'))) {
				time.unit = 'minute';
			}
			else if (mindate.isBefore(moment().subtract(5, 'minutes'))) {
				time.unit = 'minute';
			}
		}

		// Build datasets with pH where available
		const datasets: Array<Chart.ChartDataSets> = new Array<Chart.ChartDataSets>()
		loggers.forEach(logger => {

			config.scales!.yAxes!
				.find(axe => axe.id === 'y-axis-ph')!
				.display = true
			const data: any = chartData.ph
				.filter(reading => reading.loggerId === logger.id)
				.map(reading => ({
					loggerId: reading.loggerId,
					x: reading.x,
					y: reading.y,
				}))
			datasets.push({
				borderColor: logger.colour,
				data,
				fill: false,
				label: `${logger.chartLabel} (pH)`,
				pointHoverRadius: 0,
				pointRadius: 1,
				spanGaps: true,
				yAxisID: 'y-axis-ph',
			})

		})

		const myData: Chart.ChartData = {
			datasets
		}

		return (
			<Card className={css.card}>
				<Line
					data={myData}
					options={config}
				/>
			</Card>
		)
	}
}


// WEBPACK FOOTER //
// ./src/TimeSeriesChartPH.tsx